import { render, staticRenderFns } from "./nav-panel.vue?vue&type=template&id=0b8509e9"
import script from "./nav-panel.vue?vue&type=script&lang=ts"
export * from "./nav-panel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports